import { useLang } from "@/LangContext";
import { Reveal, Chapter } from "@/components/Reveal";

const IMAGES = [
  "/assets/cancha-sintetica-aerea.jpg",
  "/assets/academia-duo.jpg",
  "/assets/logo-iesdv-card.jpg",
  "/assets/rehab-duo.jpg",
];

export default function Ecosystem() {
  const { t } = useLang();

  return (
    <section
      id="ecosistema"
      data-testid="ecosystem-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter number={t.eco.chapter} label={t.eco.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-display text-3xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
            {t.eco.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            {t.eco.subtitle}
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          {t.eco.cards.map((card, i) => (
            <Reveal key={card.testid} delay={i * 0.1} className="h-full">
              <article
                data-testid={card.testid}
                className="group flex h-full flex-col overflow-hidden border border-white/10 bg-[#121620] transition-colors duration-500 hover:border-amber-400/50"
              >
                <div className="relative h-60 shrink-0 overflow-hidden sm:h-72">
                  <img
                    src={IMAGES[i]}
                    alt={card.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#121620] via-transparent to-transparent" />
                  <span className="absolute left-5 top-5 border border-amber-400/40 bg-[#0A0C10]/70 px-3 py-1 font-code text-[10px] uppercase tracking-[0.25em] text-amber-400 backdrop-blur-sm">
                    {card.badge}
                  </span>
                  <span className="absolute right-5 top-4 font-display text-4xl font-bold text-white/25">
                    {card.num}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6 sm:p-8">
                  <p className="font-code text-[10px] uppercase tracking-[0.3em] text-slate-500">
                    {card.category}
                  </p>
                  <h3 className="mt-3 font-display text-2xl font-bold uppercase leading-tight text-white sm:text-3xl">
                    {card.title}
                  </h3>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-400">
                    {card.desc}
                  </p>
                  <div className="mt-6 border-t border-white/10 pt-5">
                    <p className="font-code text-[10px] uppercase tracking-[0.3em] text-amber-400/70">
                      {t.eco.opportunityLabel}
                    </p>
                    <p className="mt-1.5 text-sm font-semibold text-amber-300">
                      {card.opportunity}
                    </p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
